import React from "react";
import ConveniosYearPage from "./ConveniosYearPage";
import { convenios2026 } from "../../../../data/Convenios/dataConvenios";

const Convenios2026 = () => <ConveniosYearPage year={2026} data={convenios2026} />;

export default Convenios2026;